// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__24Yoj","colMin":"styles_colMin__thtm7","colCheckbox":"styles_colCheckbox__2aREg"};